export default __webpack_public_path__ + "static/media/6.91c0f321.JPG";